// Cart upsell — accessoires (MNSY)
// Wordt geladen vanuit snippets/header-actions.liquid, BUITEN de drawer-content.
// Belangrijk: dit mag niet als inline <script> in de drawer-HTML staan, want die
// content wordt bij een lege cart pas via morph/innerHTML ingevoegd en zulke
// scripts voert de browser niet uit.

// 1) Pijl-navigatie van de upsell-strip (event delegation, overleeft morphs).
document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;
  const btn = target.closest('[data-upsell-scroll]');
  if (!btn) return;
  const root = btn.closest('.cart-upsell-mnsy');
  const row = root && root.querySelector('.cart-upsell-mnsy__row');
  if (!row) return;
  const item = row.querySelector('.cart-upsell-mnsy__item');
  const step = item ? item.offsetWidth + 8 : row.clientWidth * 0.8;
  const dir = btn.getAttribute('data-upsell-scroll') === 'next' ? 1 : -1;
  row.scrollBy({ left: dir * step, behavior: 'smooth' });
});

// 2) iOS scroll-lock-guard: blokkeer touchmove in de open cart drawer buiten
// gebieden die echt kunnen scrollen. Horizon's dialog.js lockt de body alleen
// met position: fixed; iOS pakt swipes op niet-scrollbare delen (bijv. de
// summary/afrekensectie) dan op als rubber-band van de hele WebView, waarbij
// alles veert en touches dood zijn tot de bounce klaar is.
document.addEventListener(
  'touchmove',
  (event) => {
    const dlg = document.querySelector('.cart-drawer__dialog[open]');
    if (!dlg) return;
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (!dlg.contains(target)) {
      event.preventDefault();
      return;
    }
    const scroller = target.closest(
      '.cart-drawer__items, .cart-upsell-mnsy__row, .cart-drawer__summary'
    );
    if (scroller) {
      const canScroll =
        scroller.scrollHeight > scroller.clientHeight + 1 ||
        scroller.scrollWidth > scroller.clientWidth + 1;
      if (canScroll) return;
    }
    event.preventDefault();
  },
  { passive: false }
);
